import { render } from "./ChatField.vue?vue&type=template&id=7ad8bf0a&scoped=true"
import script from "./ChatField.vue?vue&type=script&lang=js"
export * from "./ChatField.vue?vue&type=script&lang=js"

import "./ChatField.vue?vue&type=style&index=0&id=7ad8bf0a&lang=sass&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ad8bf0a"]])

export default __exports__